// externals
import type { Reducer } from 'redux';

// types
import { ChooseVehicleState } from '../types/stateTreeTypes';

// action types
import { initActionTypes } from '@makemydeal/dr-shared-store';

export const CHOOSE_VEHICLE_INITIAL_STATE: ChooseVehicleState = {};

export const reducer: Reducer<ChooseVehicleState> = (state: ChooseVehicleState = CHOOSE_VEHICLE_INITIAL_STATE, action: any) => {
    switch (action.type) {
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                commonOrgId: action.payload.commonOrgId,
                vin: action.payload.vin,
                stockNumber: action.payload.stockNumber,
                initialSearchValue: action.payload.initialSearchValue,
                bridgeUser: action.payload.bridgeUser,
                dealerConfig: action.payload.dealerConfig,
                dealerships: action.payload.dealerships
            };
        }
        default: {
            return state;
        }
    }
};
